import type { ReactNode } from 'react';
import { I18nProvider } from '@amzn/awsui-components-react/polaris/i18n';
import enMessages from '@amzn/awsui-components-react/polaris/i18n/messages/all.en';
import zhMessages from '@amzn/awsui-components-react/polaris/i18n/messages/all.zh-CN';

import { htmlLangFor } from './locale';
import type { Locale } from './resources';
import { useLocale } from './useLocale';

const CLOUDSCAPE_MESSAGES: Record<Locale, typeof enMessages> = {
  zh: zhMessages,
  en: enMessages,
};

/**
 * Gives Cloudscape components the UI locale's built-in text (pagination,
 * empty states, date pickers, ...).
 *
 * Wrap only the parts of the Portal in the zh/en switch. ivt/ and eventHub/
 * are deliberately left outside, so their Cloudscape text stays as it is.
 *
 * The legacy text (UI_I18N_ENABLED off) renders no provider at all, which is how
 * the Portal rendered before the switch, so the boundary changes nothing there.
 */
export default function CloudscapeI18nBoundary({ children }: { children: ReactNode }) {
  const { locale, legacy } = useLocale();
  if (legacy) return <>{children}</>;
  return (
    <I18nProvider locale={htmlLangFor(locale)} messages={[CLOUDSCAPE_MESSAGES[locale]]}>
      {children}
    </I18nProvider>
  );
}
